<template>
  <singleSelect
    v-model="selectionModel"
    track-by="key"
    :no-border="false"
    label="label"
    :top-left-label="filterMeta?.name"
    :top-right-label="selectionModel?.label"
    :header-label="selectionRangeText"
    :disabled="loading"
    :loading="loading"
    :options="validDropdownOptions"
    @input="updateSelectionModel" />
</template>

<script>
  import singleSelect from '@/components/ui/singleselect'
  import * as moment from 'moment'

  export default {
    name: 'DashboardBenchmarkFilter',
    components: {
      singleSelect,
    },
    mixins: [],
    props: {
      filterMeta: {
        type: Object,
        required: true,
      },
      value: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        selectionModel: null,
        loading: false,
        dropdownOptions: [],
      }
    },

    computed: {
      dataContext: {
        get () {
          return this.value
        },
        set (newValue) {
          this.$emit('input', newValue)
        },
      },
      validDropdownOptions () {
        return this.dropdownOptions.filter((option) =>
          this.isOffsetViable(option)
        )
      },
      defaultOption () {
        return this.dropdownOptions.find(
          (o) => o.key === this.filterMeta.default_option
        )
      },
      benchmarkDateRange () {
        const selectedDates = this.dataContext?.date_selection?.selected_dates
        const offsetDays = this.selectionModel?.offset_days
        if (
          selectedDates.length > 0 &&
          offsetDays
        ) {
          const startDate = moment(selectedDates[0])
            .add(offsetDays, 'days')
            .format('ll')
          const endDate = moment(selectedDates[selectedDates.length - 1])
            .add(offsetDays, 'days')
            .format('ll')
          return { startDate, endDate, }
        }
        return { startDate: null, endDate: null, }
      },
      selectionRangeText () {
        if (!this.selectionModel) return ''

        const startDate = this.benchmarkDateRange.startDate
        const endDate = this.benchmarkDateRange.endDate

        if (!startDate) return ''

        return `${startDate} ${
          endDate && endDate != startDate ? ` to ${endDate}` : ''
        }`
      },
    },
    watch: {
      validDropdownOptions: {
        handler () {

          //when the options are changed, make sure the selection is still valid if not reset to default is viable else first available option
          if (
            this.selectionModel &&
            !this.isOffsetViable(this.selectionModel)
          ) {
            if (this.isOffsetViable(this.defaultOption)) {
              this.updateSelectionModel(this.defaultOption)
              this.selectionModel = this.defaultOption
            } else {
              this.updateSelectionModel(this.validDropdownOptions[0])
              this.selectionModel = this.validDropdownOptions[0]
            }
          }
        },
      },
    },

    async mounted () {
      this.dropdownOptions = [...this.filterMeta.options,]
      const defaultOption = this.defaultOption || this.validDropdownOptions[0]
      // Set default selection only if there's no user selection
      if (!this.dataContext.control_selections[this.filterMeta.key]) {
        this.updateSelectionModel(defaultOption)
        this.selectionModel = defaultOption
      }
    },

    methods: {
      isOffsetViable (option) {
        const offsetDays = Math.abs(option.offset_days || 0)
        if (!offsetDays) {
          return true
        }
        let start = moment(this.dataContext.date_selection.selected_dates[0])
        let end = moment(
          this.dataContext.date_selection.selected_dates[
            this.dataContext.date_selection.selected_dates.length - 1
          ]
        )
        let durationDays = moment(end).diff(moment(start), 'days') + 1
        return offsetDays >= durationDays
      },
      updateSelectionModel (value) {
        this.$set(this.dataContext.control_selections, this.filterMeta.key, {
          type: this.filterMeta.type,
          selected_option: value.key,
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
::v-deep .dropdown-menu {
  padding-top: 4px !important;
  .dropdown-content {
    border-radius: 6px !important;
  }
}
</style>
